/**
 * 地域を扱うdojo/store
 *
 * 外部向けでJSONファイルを読み込んで利用する場合に使う
 *
 * @module app/model/CrisisManageRiverLevelObsavatoryStore
 */
define([
    'dstore/legacy/DstoreAdapter',
    'dstore/RequestMemory'
], function(DstoreAdapter, RequestMemory) {
    /**
     * シングルトンを返す。
     */
    return new RequestMemory({
        idProperty: 'observatoryId',
        target: '/data/master/observatory/crisisManageRiverLevelObservatory.json'
    });

});
